import { render } from "./routesView.vue?vue&type=template&id=01a4e5df"
import script from "./routesView.vue?vue&type=script&lang=js"
export * from "./routesView.vue?vue&type=script&lang=js"

import "./routesView.vue?vue&type=style&index=0&id=01a4e5df&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__